<div class="innerBanner">
    <div class="container md">
        <div class="viewerAssign">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="">
                        <a href="javascript:void(0);" *ngIf="view !=2" class="backLink"
                            [routerLink]="['/assigned_details_resume']"
                            [queryParams]="{courseId:capsuleDataSubModulesData.course_id}"><b><img
                                    src="assets/images/icons/backarrow.png" /></b>BACK TO COURSE DETAILS</a>
                        <a href="javascript:void(0);" *ngIf="view ==2" class="backLink"
                            [routerLink]="['/completed_details']" [queryParams]="{courseId:courseId}"><b><img
                                    src="assets/images/icons/backarrow.png" /></b>BACK TO COURSE DETAILS</a>
                    </div>
                    <div class="viewerModule">
                        <h2>{{capsuleData?.module_name}}</h2>

                    </div>
                    <div class="viewerSubModule">
                        <div class="viewerSubTitle">
                            <span>{{capsuleDataSubModulesData?.submodule_name}}</span>
                            <h2>{{capsuleDataSubModulesData?.submodule_desc}}</h2>
                        </div>

                    </div>
                </div>
                <div class="col-12 col-md-6" *ngIf="view!=1 && view!=2">
                    <div class="moduleTimerWrap">
                        <div class="joinerDetails">
                            <span class="joinerDetailsImage">
                                <img src="assets/images/icons/doughnut_chart.svg">
                            </span>
                            <div class="joinerContent">
                                <h3>{{ completePercent | number : '1.0-0' }}%</h3>
                                <p>Module completed</p>
                                <!-- <div class="ghrapWrap mb-0">
                                    <span [style.width.%]="completePercent"></span>
                                </div> -->
                            </div>
                        </div>

                    <div class="timerWrap">
                        <ul *ngIf="getElapsedTime() as elapsed">
                            <li>
                                <div class="timer">
                                    <span *ngIf="view!=1 && view!=2">{{elapsedTime.hours | number:'2.0-0'}}</span>
                                    <span *ngIf="view == 1 || view == 2">00</span>
                                    <small>hrs</small>
                                </div>
                            </li>
                            <li>
                                <b>:</b>
                            </li>
                            <li>
                                <div class="timer">
                                    <span *ngIf="view!=1 && view!=2">{{elapsedTime.minutes | number:'2.0-0'}}</span>
                                    <span *ngIf="view == 1 || view == 2">00</span>
                                    <small>min</small>
                                </div>
                            </li>
                            <li>
                                <b>:</b>
                            </li>
                            <li>
                                <div class="timer">
                                    <span *ngIf="view!=1 && view!=2">{{elapsedTime.seconds | number:'2.0-0'}}</span>
                                    <span *ngIf="view == 1 || view == 2">00</span>
                                    <small>sec</small>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                    <div class="viewerSetIcons">
                        <div class="">
                        <p>Sub module contains</p>
                        <ul class="modifyIcons" *ngIf="capsuleDataSubModulesData">
                            <li *ngIf="capsuleDataSubModulesData.media_type && capsuleDataSubModulesData.media_type[0]==1"><a
                                    href="javascript:void(0);"><img src="assets/images/icons/text.svg"></a></li>
                            <li *ngIf="capsuleDataSubModulesData.media_type && capsuleDataSubModulesData.media_type[1]==1"><a
                                    href="javascript:void(0);"><img src="assets/images/icons/text.svg"></a></li>
                            <li *ngIf="capsuleDataSubModulesData.media_type && capsuleDataSubModulesData.media_type[2]==1"><a
                                    href="javascript:void(0);"><img src="assets/images/icons/text.svg"></a></li>
                            <li *ngIf="capsuleDataSubModulesData.media_type && capsuleDataSubModulesData.media_type[0]==2"><a
                                    href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg"></a></li>
                            <li *ngIf="capsuleDataSubModulesData.media_type && capsuleDataSubModulesData.media_type[1]==2"><a
                                    href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg"></a></li>
                            <li *ngIf="capsuleDataSubModulesData.media_type && capsuleDataSubModulesData.media_type[2]==2"><a
                                    href="javascript:void(0);"><img  src="assets/images/icons/insert-picture.svg"></a></li>
                            <li *ngIf="capsuleDataSubModulesData.media_type && capsuleDataSubModulesData.media_type[0]==3"><a
                                    href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg"></a>
                            </li>
                            <li *ngIf="capsuleDataSubModulesData.media_type && capsuleDataSubModulesData.media_type[1]==3"><a
                                    href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg"></a>
                            </li>
                            <li *ngIf="capsuleDataSubModulesData.media_type && capsuleDataSubModulesData.media_type[2]==3"><a
                                    href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg"></a>
                            </li>
                            <li *ngIf="capsuleDataSubModulesData?.assessment_id"><a href="javascript:void(0);"><img
                                        src="assets/images/icons/frame.svg"></a></li>
                        </ul>
                    </div>
                </div>

                </div>
            </div>
        </div>
    </div>
</div>
<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="formHeading d-none">
    <div class="container">
        <div class="row m-0">
            <div class="col-12 col-md-10">
                <h2>View Content Capsule</h2>
                <p>Advance Level Course - Railway Track Maintenence with Assessment</p>
            </div>
        </div>
    </div>
</div>
<div class="viewTabWrap">
    <div class="tabsWrap">
        <div class="container md">
            <mat-tab-group animationDuration="0ms" [selectedIndex]="activeTab">

                <mat-tab *ngFor="let values of subModuleData; let i = index">
                    <!-- {{values|json}} -->
                    <ng-template mat-tab-label>
                        <b>Submodule {{values.submodule_num}}:</b>
                        <span class="moduleName" (click)="capsuleDetail(this.userLoginData.user_id, values.module_id, values.submodule_id);">{{values.submodule_name}}</span>

                    </ng-template>
                    <div class="contentBody">
                        <mat-horizontal-stepper #stepper [@.disabled]="true"
                            selectedIndex="{{capsuleDataSubModulesData.last_index_seen}}" preventCopyPaste
                            onmousedown="return false" onselectstart="return false">
                            <mat-step *ngFor="let subValues of capsuleDataSubModulesData.media_data; let j = index">
                                <div class="stepperCenter">
                                    <div class="container-fluid">

                                        <div class="grindHeadWrap">
                                            <h3>Grind Module</h3>
                                            <div class="grindHeadRight">
                                                <!-- <button mat-button matStepperPrevious *ngIf="j !=0"> <img
                                                    src="assets/images/icons/preview-arrow.png" /> Previous</button> -->
                                                    <button mat-button matStepperPrevious *ngIf="j !=0"> <i><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <circle cx="9" cy="9" r="9" transform="rotate(-90 9 9)" fill="#F06715"/>
                                                        <path d="M6.06702 8.57574C5.83271 8.81005 5.83271 9.18995 6.06702 9.42426L9.8854 13.2426C10.1197 13.477 10.4996 13.477 10.7339 13.2426C10.9682 13.0083 10.9682 12.6284 10.7339 12.3941L7.33981 9L10.7339 5.60589C10.9682 5.37157 10.9682 4.99167 10.7339 4.75736C10.4996 4.52304 10.1197 4.52304 9.8854 4.75736L6.06702 8.57574ZM7.18359 8.4H6.49129V9.6H7.18359V8.4Z" fill="white"/>
                                                      </svg></i> Previous</button>
                                                        <button mat-button matStepperNext *ngIf="capsuleDataSubModulesData.media_data.length-1 != j" (click)="nextSlide(j+1,capsuleDataSubModulesData.submodule_id)">Next<i><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                            <circle cx="9" cy="9" r="9" transform="rotate(90 9 9)" fill="#F06715"/>
                                                            <path d="M11.933 9.42426C12.1673 9.18995 12.1673 8.81005 11.933 8.57574L8.1146 4.75736C7.88029 4.52304 7.50039 4.52304 7.26607 4.75736C7.03176 4.99167 7.03176 5.37157 7.26607 5.60589L10.6602 9L7.26607 12.3941C7.03176 12.6284 7.03176 13.0083 7.26607 13.2426C7.50039 13.477 7.88029 13.477 8.1146 13.2426L11.933 9.42426ZM10.8164 9.6H11.5087V8.4H10.8164V9.6Z" fill="white"/>
                                                          </svg></i></button>
                                            <!-- <button mat-button matStepperNext
                                                *ngIf="capsuleDataSubModulesData.media_data.length-1 != j"
                                                (click)="nextSlide(j+1,capsuleDataSubModulesData.submodule_id)">Next<img
                                                    src="assets/images/icons/next-arrow.png" /></button> -->
                                            <button mat-button matStepperNext
                                                *ngIf="capsuleDataSubModulesData.media_data.length-1 == j && capsuleDataSubModulesData.assessment_id == null && view_button == 0"
                                                (click)="finishSubModule(j+1)">Finish Sub Module</button>
                                            <!-- <button mat-button matStepperNext
                                *ngIf="view==1 && capsuleDataSubModulesData.media_data.length-1 ==j" (click)="finishSubModule(view)">Finish Sub Module</button> -->
                                            <button class="btn btn-primary takeass"
                                                *ngIf="capsuleDataSubModulesData.media_data.length-1 ==j && view !=1 && view !=2  && capsuleDataSubModulesData.assessment_id != null && view_button == 0"
                                                (click)="goToAssessment(j+1)">Take Assessments</button>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="viverContent" *ngIf="subValues.media_type==1">
                                                <div class="viverContentList pl-0 pt-0">
                                                    <h4 *ngIf="(subValues.media_type==2 || subValues.media_type==3)">
                                                        {{subValues.media_title}}</h4>
                                                    <p class="pt-3" [innerHtml]='subValues.media_content'></p>


                                                </div>
                                            </div>
                                            <div class="col-lg-12"
                                                *ngIf="subValues.media_title !='' && subValues.media_type==2">
                                                <h4>{{subValues?.media_title}}</h4>
                                            </div>
                                            <div class="viverContent" *ngIf="subValues.media_type==2">
                                                <div class="viverContentList" *ngIf="subValues.media_content !=''">
                                                    <p class="pt-3" *ngIf="subValues.media_content !=''"
                                                        [innerHtml]='subValues?.media_content'></p>
                                                </div>
                                                <div class="viverContentList imgVideoViver" *ngIf="subValues.media_path">
                                                    <div class="imageWrap">
                                                        <img src={{subValues.media_path}}>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-12"
                                                *ngIf="subValues.media_title !='' && subValues.media_type==3">
                                                <h4>{{subValues?.media_title}}</h4>
                                            </div>
                                            <div class="viverContent" *ngIf="subValues.media_type==3">
                                                <div class="viverContentList" *ngIf="subValues.media_content !=''">
                                                    <p class="pt-3" [innerHtml]='subValues.media_content'></p>
                                                </div>
                                                <div class="viverContentList imgVideoViver" *ngIf="subValues.media_path !=''">
                                                    <div class="imageWrap">
                                                        <!-- <video controls>
                                            <source src={{subValues.media_path}} type="video/mp4">
                                            Sorry, your browser doesn't support embedded videos.
                                        </video> -->
                                                        <video fireVideo src={{subValues.media_path}} controls="true"
                                                            muted width="400" controlsList="nodownload"
                                                            oncontextmenu="return false;">
                                                            Sorry, your browser doesn't support embedded videos.
                                                        </video>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- <button class="btn btn-primary takeass"
                                 *ngIf="capsuleDataSubModulesData.media_data.length-1 ==j && capsuleDataSubModulesData.assessment_id != null"
                                  (click)="goToAssessment()">Take Assessments</button> -->
                                            <div class="pagecountNumber "><b class="">{{j+1}}</b>/<b
                                                    class="">{{capsuleDataSubModulesData.media_data.length}}</b> </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-step>
                        </mat-horizontal-stepper>
                        <div class="pagiMainWrap">
                            <div class="container">
                                <div class="row">
                                    <div class="pagiWrap">
                                        <div class="pagecount "><b class="d-none">1</b><b class="d-none">5</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>

        </div>
        <input type="hidden" (click)="open1(multiloginValidation)" id="validationMsg">
    </div>
</div>

<ng-template #multiloginValidation let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close"
                (click)="navigationEvent();modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <p class="size18">Please logout from other devices or login again to continue using the portal here</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="navigationEvent();modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
</ng-template>
